import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class ViewArchivedCoverNoteContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.VIEW_ARCHIVED_COVER_NOTE}/>
        );
    }
}

export default ViewArchivedCoverNoteContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/ViewArchivedCoverNoteContainer.tsx